import { render, staticRenderFns } from "./ItemAuthorActions.vue?vue&type=template&id=3ec08cb8"
import script from "./ItemAuthorActions.vue?vue&type=script&lang=ts"
export * from "./ItemAuthorActions.vue?vue&type=script&lang=ts"
import style0 from "./ItemAuthorActions.vue?vue&type=style&index=0&id=3ec08cb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports